import { render, staticRenderFns } from "./portSelect.vue?vue&type=template&id=5d050394&scoped=true"
import script from "./portSelect.vue?vue&type=script&lang=js"
export * from "./portSelect.vue?vue&type=script&lang=js"
import style0 from "./portSelect.vue?vue&type=style&index=0&id=5d050394&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d050394",
  null
  
)

export default component.exports